import axios from 'axios';
import qs from 'qs';
import Cookies from 'js-cookie';
import API from './api';

const APICall = {};
var accessToken = Cookies.get('access_token');
var userId = Cookies.get('user_id') ?? 0;

APICall.Signup = (data, callback) => {
const endpoint = '/users/';
    axios({
        method: 'POST',
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'create_account',
            'fatal': false
        })
    })
}


APICall.Login = (data, callback) => {
    const endpoint = '/users/login/';
    axios({
        method: 'POST',
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'login',
            'fatal': false
        })
    })
}


APICall.ClaimBusiness = (data, token, callback) => {
    const endpoint = '/business/claim/';
    axios({
        method: 'POST',
        data: data,
        headers: { Authorization: `Bearer ${token}` },
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'claim_business',
            'fatal': false
        })
    })
}


APICall.LogOut = (callback) => {
    const endpoint = '/users/logout/';
    accessToken = Cookies.get('access_token');
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        if (response.status == 200){
            Cookies.remove('access_token');  
            Cookies.remove('token_expires_in');
            Cookies.remove('username');
            Cookies.remove('rs11_user_id');
            window.localStorage.removeItem("claimBusiness");
            window.localStorage.removeItem('userSelectedBusiness');
            callback(response);
        }
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'logout',
            'fatal': false
        })
    })
}


APICall.GetAccountDetails = (token, callback) => {
    const endpoint = '/users/details/';
    axios({
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'get_account_settings',
            'fatal': false
        })
    })
}

APICall.UpdateAccountDetails = (data, token, callback) => {
    const endpoint = '/users/details/';
    axios({
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}` },
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'update_account_settings',
            'fatal': false
        })
    })
}


APICall.AddNewBusiness = (data, token, callback) => {
    const endpoint = '/business/add/';
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'add_new_business',
            'fatal': false
        })
    })
}


APICall.VerifyEmail = (token, callback) => {
    const endpoint = '/users/verify/?token=';
    axios({
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}${token}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'verify_mail',
            'fatal': false
        })
    })
}


APICall.GetBusinessData = (params, callback) => {
    const endpoint = '/business/data/'
    axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`,
        params: params
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'get_business_without_valuation',
            'fatal': false
        })
    })
}

APICall.GetBusinessValuation = (params, accessTokenValue, callback) => {
    const endpoint = '/business/details/'
    axios({
        method: 'GET',
        headers: { Authorization: `Bearer ${accessTokenValue}` },
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`,
        params: params
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'get_business_with_valuation',
            'fatal': false
        })
    })
}


APICall.CreateAccount = (data, callback) => {
    const endpoint = '/users/';
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'create_account',
            'fatal': false
        })
    })
}


APICall.ResendMail = (data, callback) => {
    const endpoint = '/users/resend/';
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'resend_mail',
            'fatal': false
        })
    })
}


APICall.SetPassword = (data, callback) => {
    const endpoint = '/users/set-password/';
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'set_password',
            'fatal': false
        })
    })
}


APICall.SocialLogin = (data, callback) => {
    const endpoint = '/users/social-account/';
        axios({
            method: 'POST',
            data: data,
            url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
        })
        .then(function(response) {
            callback(response);
        })
        .catch(function(error) {
            callback(error.response);
            window.dataLayer.push({
                'event': 'exception',
                'description': 'API error',
                'apiName': 'social_sign_in',
                'fatal': false
            })
        })
}


APICall.AppleSignin = (data, callback) => {
    const endpoint = '/users/apple-signin/';
        axios({
            method: 'POST',
            data: data,
            url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
        })
        .then(function(response) {
            callback(response);
        })
        .catch(function(error) {
            callback(error.response);
            window.dataLayer.push({
                'event': 'exception',
                'description': 'API error',
                'apiName': 'apple_sign_in',
                'fatal': false
            })
        })
}

    
APICall.AddBusinessLike = (data, token, callback) => {
    const endpoint = "/business/likes/";
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'like_business',
            'fatal': false
        })
    })
}


APICall.ForgotPasswordEmail = (data, callback) => {
    const endpoint = "/users/forgot-password/";
    axios({
        method: 'POST',
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'forgot_password',
            'fatal': false
        })
    })
}


APICall.VerifyResetPassword = (token, callback) => {
    const endpoint = "/users/forgot-password/verify/?token=";
    axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}${token}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'verify_forgot_link',
            'fatal': false
        })
    })
}


APICall.ChangePassword = (data, callback) => {
    const endpoint = "/users/change-password/";
    axios({
        method: 'POST',
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'reset_password',
            'fatal': false
        })
    })
}


APICall.BusinessShare = (data, token, callback) => {
    const endpoint = "/business/shares/";
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'share_business',
            'fatal': false
        })
    })
}


APICall.ContactBusiness = (data, token, callback) => {
    const endpoint = "/business/contact/";
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'contact_business',
            'fatal': false
        })
    })
}


APICall.DisputeBusiness = (data, token, callback) => {
    const endpoint = "/business/valuation-feedback/";
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'valuation_business',
            'fatal': false
        })
    })
}

APICall.GetLikedBusinesses = (token, limit, offSet, callback) => {
    const endpoint = "/business/likes/list/";
    axios({
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}?limit=${limit}&offset=${offSet}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
        window.dataLayer.push({
            'event': 'exception',
            'description': 'API error',
            'apiName': 'get_liked_businesses',
            'fatal': false
        })
    })
}

APICall.BusinessInterest = (data, token, callback) => {
    const endpoint = "/business/interests/";
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
}

APICall.SetNewPassword = (data, callback) => {
    const endpoint = "/users/set-password/";
    axios({
        method: 'POST',
        data: data,
        url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
}

APICall.CheckSetPassword = (data, callback) => {
    const endpoint = '/users/check/';
        axios({
            method: 'POST',
            data: data,
            url: `${process.env.REACT_APP_BASE_URL}${endpoint}`
        })
        .then(function(response) {
            callback(response);
        })
        .catch(function(error) {
            callback(error.response);
        })
    }

export default APICall;